/**
 * "Continue with Google" — starts the auth service's Google flow.
 *
 * The browser has to leave the app for Google and come back to
 * `/auth/google/callback`, so this is a navigation rather than a fetch: the
 * server answers the request with a redirect to the provider.
 */

interface GoogleSignInButtonProps {
  /** Same-origin path to land on after the round trip. */
  next?: string
  /** Keep the session after the browser closes. */
  remember?: boolean
  label?: string
  disabled?: boolean
}

export function GoogleSignInButton({
  next,
  remember = false,
  label = 'Continue with Google',
  disabled = false,
}: GoogleSignInButtonProps) {
  function start() {
    const params = new URLSearchParams()
    if (next) params.set('next', next)
    if (remember) params.set('remember', '1')
    const query = params.toString()
    location.assign(`/api/session/oauth/google${query ? `?${query}` : ''}`)
  }

  return (
    <button type="button" onClick={start} className="btn-outline w-full justify-center" disabled={disabled}>
      <svg viewBox="0 0 24 24" width="16" height="16" aria-hidden="true">
        <path
          fill="#4285F4"
          d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92a5.06 5.06 0 0 1-2.2 3.32v2.76h3.57c2.08-1.92 3.27-4.74 3.27-8.09Z"
        />
        <path
          fill="#34A853"
          d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.76c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84A11 11 0 0 0 12 23Z"
        />
        <path fill="#FBBC05" d="M5.84 14.11a6.6 6.6 0 0 1 0-4.22V7.05H2.18a11 11 0 0 0 0 9.9l3.66-2.84Z" />
        <path
          fill="#EA4335"
          d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1A11 11 0 0 0 2.18 7.05l3.66 2.84c.87-2.6 3.3-4.51 6.16-4.51Z"
        />
      </svg>
      {label}
    </button>
  )
}
